import {
  ApiInterface,
  EmptyObject,
  PaginatedQueryParams,
  PaginatedResponse,
} from '@stetamalo/cloud-platform/catalog/api';
import { ApiConfig } from 'services/support/utils/types/api-config';
import { Lashitas } from '../../entities/lashitas';

export type Interface = ApiInterface<{
  response: PaginatedResponse<Lashitas>;
  pathParams: EmptyObject;
  body: EmptyObject;
  claims: { tenantId: string };
  queryParams: PaginatedQueryParams;
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-list-lashitas',
  method: 'GET',
  basePath: 'lashitas',
  path: '/',
  tablePermission: 'read',
  scope: 'ADMIN',
};
